import { ExternalLink } from 'lucide-react';
import { GPT } from '../types';

interface GPTCardProps {
  gpt: GPT;
}

const GPTCard: React.FC<GPTCardProps> = ({ gpt }) => {
  const isActive = gpt.isActive !== false; // Default to true if not set

  return (
    <div className={`gpt-card relative bg-[#21282D] rounded-xl border border-gray-600 p-6 transition-all duration-300 group ${
      isActive 
        ? 'hover:shadow-lg' 
        : 'opacity-60 cursor-not-allowed'
    }`}>
      <div className="relative z-10">
        <div className="flex items-start justify-between mb-3">
          <h3 className={`text-lg font-semibold transition-colors duration-200 ${
            isActive 
              ? 'text-gray-100 group-hover:text-red-400' 
              : 'text-gray-500'
          }`}>
            {gpt.name}
            {!isActive && <span className="ml-2 text-xs text-gray-400">(Inactive)</span>}
          </h3>
          <ExternalLink className={`w-4 h-4 transition-colors duration-200 ${
            isActive 
              ? 'text-gray-400 group-hover:text-red-600' 
              : 'text-gray-300'
          }`} />
        </div>
        
        <p className={`text-sm mb-4 ${
          isActive ? 'text-gray-300' : 'text-gray-400'
        }`}>
          {gpt.description}
        </p>
        
        <div className="mb-4">
          <h4 className={`text-sm font-medium mb-2 ${
            isActive ? 'text-gray-100' : 'text-gray-500'
          }`}>KEY USE CASES</h4>
          <ul className="space-y-1">
            {gpt.useCases.map((useCase: string, index: number) => (
              <li key={index} className="flex items-center text-sm text-gray-300">
                <span className={`w-1.5 h-1.5 rounded-full mr-2 flex-shrink-0 ${
                  isActive ? 'bg-red-500' : 'bg-gray-300'
                }`}></span>
                <span className={isActive ? 'text-gray-300' : 'text-gray-400'}>
                  {useCase}
                </span>
              </li>
            ))}
          </ul>
        </div>
        
        <div className="mb-4">
          <h4 className={`text-sm font-medium mb-2 ${
            isActive ? 'text-gray-100' : 'text-gray-500'
          }`}>TAGS</h4>
          <div className="flex flex-wrap gap-1">
            {gpt.tags.map((tag: string) => (
              <span key={tag} className={`inline-block px-2 py-1 text-xs font-medium rounded ${
                isActive 
                  ? 'bg-gray-600 text-gray-100' 
                  : 'bg-gray-700 text-gray-400'
              }`}>
                {tag}
              </span>
            ))}
          </div>
        </div>
        
        {isActive ? (
          <a
            href={gpt.chatGptUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary w-full flex items-center justify-center space-x-2"
          >
            <span>Open in ChatGPT</span>
            <ExternalLink className="w-4 h-4" />
          </a>
                            ) : (
                      <div className="w-full flex items-center justify-center space-x-2 py-3 px-4 bg-gray-700 text-gray-400 rounded-lg cursor-not-allowed">
                        <span>Coming Soon</span>
                      </div>
                    )}
      </div>
    </div>
  );
};

export default GPTCard; 